import React from 'react';
import { Button, Col, Row } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { AdditionalItem } from '@/hooks';
import { Text } from '@/components/Typography';
import { riskColors } from '@/components/views/EwaJdsD86/Report/components/ConditionCard';
import { useSelectDependentInputsList } from './_hooks/useSelectDependentInputsList';
import {
	RowStyled,
	ListStyled,
	ColorScale,
	InfoContainer,
	ButtonWrapper
} from '@/components/views/EwaJdsD86/Report/components/styles';

interface RadioOption {
	id: string;
	description: string;
}

interface SelectDependentInputsListProps {
	items: AdditionalItem;
	radioOptions: RadioOption[];
	onDeleteValue: (id: string) => void;
}

export function SelectDependentInputsList({
	items,
	radioOptions,
	onDeleteValue
}: Readonly<SelectDependentInputsListProps>): JSX.Element {
	const { entries, actionTitle } = useSelectDependentInputsList({ items, radioOptions });

	return (
		<Row>
			<Col span={22}>
				<ListStyled>
					<Row gutter={[0, 10]}>
						{entries.map(({ entryId, actionLabel, riskScore, fieldRows }) => (
							<Col span={24} key={entryId}>
								<Row gutter={[8, 0]}>
									<Col span={2}>
										<ColorScale $riskColor={riskColors[riskScore]} />
									</Col>
									<Col span={22}>
										<RowStyled>
											<InfoContainer xs={20} xxl={22}>
												<Row gutter={[14, 10]}>
													<Col span={24}>
														<Text>
															<Text strong>{actionTitle}</Text>: {actionLabel}
														</Text>
													</Col>
													{fieldRows.map(({ title, value }) => (
														<Col key={title} xs={24} xxl={12}>
															<Text>
																<Text strong>{title}</Text>: {value}
															</Text>
														</Col>
													))}
												</Row>
											</InfoContainer>
											<ButtonWrapper xs={4} xxl={2}>
												<Button
													danger
													type="primary"
													id={entryId}
													icon={<DeleteOutlined />}
													style={{ width: '100%', height: '100%' }}
													onClick={(e) => onDeleteValue(e.currentTarget.id)}
												/>
											</ButtonWrapper>
										</RowStyled>
									</Col>
								</Row>
							</Col>
						))}
					</Row>
				</ListStyled>
			</Col>
		</Row>
	);
}
